import * as React from 'react';
import { requestStardogVoiceboxGenesis } from 'vet-bones/utils/voicebox';

import { notificationsActionCreators } from 'src/actions/notifications/actionCreators';
import { Project } from 'src/store/state/projects';
import { useDefaultPortalConnection } from 'src/utils/hooks/useDefaultPortalConnection';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { buildGenerateDataParameters } from 'src/utils/voicebox/hooks/parameters';
import {
  GenerateDataRequest,
  GenerateDataResponse,
} from 'src/utils/voicebox/hooks/types';

export const useGenerateData = () => {
  const dispatch = useReduxDispatch();
  const defaultConnection = useDefaultPortalConnection();

  return React.useCallback(
    async ({
      project,
      classIris,
    }: {
      project: Project;
      classIris?: string[];
    }): Promise<GenerateDataResponse | null> => {
      if (!defaultConnection) {
        return null;
      }

      try {
        const response = await requestStardogVoiceboxGenesis<
          GenerateDataRequest,
          GenerateDataResponse
        >({
          connectionIdx: defaultConnection.index,
          body: {
            endpoint: defaultConnection.endpoint,
            action: 'generate_data',
            parameters: buildGenerateDataParameters({
              project,
              classIris,
            }),
          },
        });

        if (response.error) {
          throw new Error(response.error);
        }

        return response.results || null;
      } catch (err) {
        dispatch(notificationsActionCreators.voiceboxGenerateDataFailed());
        return null;
      }
    },
    [defaultConnection, dispatch]
  );
};
